import axios from 'axios';

export const getCampaign = async orderId => {
  const { data } = await axios.get(`campaign/?orderId=${orderId}`);

  return data;
};
